module.exports = require("express-graphql");


//////////////////
// WEBPACK FOOTER
// external "express-graphql"
// module id = 14
// module chunks = 0